import React from 'react'
import { Link } from 'react-router-dom'
import { FiMail, FiLinkedin, FiTwitter, FiInstagram } from 'react-icons/fi'

export const SpotlightFooter: React.FC = () => {
  return (
    <div className="bg-teal-700 mt-auto py-12">
      <div className="container-custom max-w-7xl">
        <div className="flex flex-col gap-8">
          {/* Main Footer Content */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full">
            {/* Navigation Links */}
            <div className="flex flex-col items-center md:items-start gap-3">
              <p className="text-sm font-bold text-white uppercase tracking-wide">
                Navigation
              </p>
              <div className="flex flex-col items-center md:items-start gap-2">
                <Link to="/" className="no-underline">
                  <span className="text-sm text-teal-100 hover:text-white transition-colors duration-200">
                    Home
                  </span>
                </Link>
                <Link to="/how-it-works" className="no-underline">
                  <span className="text-sm text-teal-100 hover:text-white transition-colors duration-200">
                    How It Works
                  </span>
                </Link>
                <Link to="/for-practitioners" className="no-underline">
                  <span className="text-sm text-teal-100 hover:text-white transition-colors duration-200">
                    For Practitioners
                  </span>
                </Link>
                <Link to="/pricing" className="no-underline">
                  <span className="text-sm text-teal-100 hover:text-white transition-colors duration-200">
                    Pricing
                  </span>
                </Link>
                <Link to="/samples" className="no-underline">
                  <span className="text-sm text-teal-100 hover:text-white transition-colors duration-200">
                    Samples
                  </span>
                </Link>
                <Link to="/faq" className="no-underline">
                  <span className="text-sm text-teal-100 hover:text-white transition-colors duration-200">
                    FAQ
                  </span>
                </Link>
              </div>
            </div>

            {/* Legal Links */}
            <div className="flex flex-col items-center md:items-start gap-3">
              <p className="text-sm font-bold text-white uppercase tracking-wide">
                Legal
              </p>
              <div className="flex flex-col items-center md:items-start gap-2">
                <Link to="https://livewello.com/privacy" target="_blank" rel="noopener noreferrer" className="no-underline">
                  <span className="text-sm text-teal-100 hover:text-white transition-colors duration-200">
                    Privacy Policy
                  </span>
                </Link>
                <Link to="https://livewello.com/terms" target="_blank" rel="noopener noreferrer" className="no-underline">
                  <span className="text-sm text-teal-100 hover:text-white transition-colors duration-200">
                    Terms of Service
                  </span>
                </Link>
                <Link to="https://livewello.com" target="_blank" rel="noopener noreferrer" className="no-underline">
                  <span className="text-sm text-teal-100 hover:text-white transition-colors duration-200">
                    Livewello Main Site
                  </span>
                </Link>
              </div>
            </div>

            {/* Contact & Social */}
            <div className="flex flex-col items-center md:items-start gap-3">
              <p className="text-sm font-bold text-white uppercase tracking-wide">
                Connect
              </p>
              <div className="flex flex-col items-center md:items-start gap-2">
                <Link to="mailto:support@livewello.com" className="no-underline">
                  <div className="flex items-center gap-2">
                    <FiMail className="text-teal-200" />
                    <span className="text-sm text-teal-100 hover:text-white transition-colors duration-200">
                      support@livewello.com
                    </span>
                  </div>
                </Link>
              </div>

              {/* Social Media Icons */}
              <div className="flex items-center gap-4 pt-2">
                <Link to="https://linkedin.com/company/livewello" target="_blank" rel="noopener noreferrer">
                  <div className="p-2 rounded-full bg-teal-600 hover:bg-teal-500 hover:-translate-y-0.5 transition-all duration-200">
                    <FiLinkedin className="text-white w-4 h-4" />
                  </div>
                </Link>
                <Link to="https://twitter.com/livewello" target="_blank" rel="noopener noreferrer">
                  <div className="p-2 rounded-full bg-teal-600 hover:bg-teal-500 hover:-translate-y-0.5 transition-all duration-200">
                    <FiTwitter className="text-white w-4 h-4" />
                  </div>
                </Link>
                <Link to="https://instagram.com/livewello" target="_blank" rel="noopener noreferrer">
                  <div className="p-2 rounded-full bg-teal-600 hover:bg-teal-500 hover:-translate-y-0.5 transition-all duration-200">
                    <FiInstagram className="text-white w-4 h-4" />
                  </div>
                </Link>
              </div>
            </div>
          </div>

          <hr className="border-teal-600" />

          {/* Copyright */}
          <div className="flex justify-between items-center w-full flex-wrap gap-4">
            <p className="text-xs text-teal-200">
              © {new Date().getFullYear()} Livewello Spotlight. All rights reserved.
            </p>
            <p className="text-xs text-teal-300">
              Made with care for transformation-focused service providers and outcome-driven product brands everywhere.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
